import { useTranslation } from 'react-i18next';
import { type CapiProductPage } from 'types/capi/pdp';

import Price from '~/components/Price';
import usePageData from '~/hooks/usePageData';
import SellNowButton from '~/routes/pdps/affiliate/SellNowButton';

export default function ProductMetaData({
  showPrice = true
}: {
  showPrice?: boolean;
}) {
  const product = usePageData<CapiProductPage>();
  const { t } = useTranslation('pdp');

  return (
    <div className="flex flex-col gap-2 font-normal">
      <div className="flex w-full items-center ">
        <h1 data-cy="product-name" className="text-title-md">
          {product.name}
        </h1>
        {product.allow_sell_now && (
          <div className="ml-auto hidden text-base font-semibold lg:block">
            <SellNowButton
              productId={product.product_id}
              source="pdp"
              buttonStyle="normal"
            />
          </div>
        )}
      </div>
      <div
        className={`items-center gap-2 font-heading ${showPrice ? 'flex' : 'hidden'}`}
      >
        {t('priceFrom')}
        <Price
          className="gap-2 font-semibold"
          regular={product.price.regular}
          sale={product.price.sale}
          currency={product.price.currency}
        />
      </div>
    </div>
  );
}
